import React from "react";
import { IconArrowsHorizontal, IconArrowsVertical } from "@hubble/icons";
import { Button, mediaQuery } from "@hubble/web";
import { TEST_IDS } from "constants/converter";
import { useMedia } from "react-use";

interface SwapButtonProps {
  handleSwap: () => void;
}

const SwapButton: React.FC<SwapButtonProps> = ({ handleSwap }) => {
  const isMobileXsDown = useMedia(mediaQuery.mobileXsDown, false);

  return (
    <Button.Secondary
      data-testid={TEST_IDS.SWAP_BUTTON}
      aria-label="swap-button"
      icon={isMobileXsDown ? <IconArrowsVertical /> : <IconArrowsHorizontal />}
      onClick={handleSwap}
      style={isMobileXsDown ? { marginLeft: "10px" } : {}}
    />
  );
};
export default SwapButton;
